// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"UserEventsPage_pageWrapper__CtAIq"};